import { useDeviceInfoStore } from '@/stores/DeviceStore';

//* 서버·hydration 렌더에서는 파트너가 undefined라 ready가 빠지고, 파트너로 재렌더된 컴포넌트만 스스로 ready를 단다
export const usePartnerChromeClassName = () => {
  const isPartnerResolved = useDeviceInfoStore(
    (state) => state.subDomain !== undefined,
  );

  return isPartnerResolved
    ? 'partner-chrome partner-chrome-ready'
    : 'partner-chrome';
};
